var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTheoryIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.80915 2.90218C8.80915 4.06539 7.87017 5.00437 6.70696 5.00437C5.54375 5.00437 4.60477 4.06539 4.60477 2.90218C4.60477 1.73897 5.54375 0.799988 6.70696 0.799988C7.87017 0.799988 8.80915 1.73897 8.80915 2.90218ZM0.400391 5.00437C2.83893 5.00437 5.05324 5.95035 6.70696 7.49196C8.36068 5.95035 10.575 5.00437 13.0135 5.00437V12.7124C10.575 12.7124 8.36068 13.6654 6.70696 15.2C5.05324 13.6584 2.83893 12.7124 0.400391 12.7124V5.00437Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheoryIcon);
export default __webpack_public_path__ + "static/media/theory-icon.d7c3479af27913b27891be07484ae63c.svg";
export { ForwardRef as ReactComponent };